'use client'

import { TonConnectUIProvider } from '@tonconnect/ui-react'
import { ReactNode } from 'react'

interface TonProviderProps {
    children: ReactNode
}

/**
 * TON Connect Provider
 * Wraps the app with TonConnectUIProvider for wallet connectivity
 */
export function TonProvider({ children }: TonProviderProps) {
    // The manifest URL should point to a publicly accessible JSON file
    // Using the API route ensures proper CORS headers and bypasses ngrok's interstitial
    const manifestUrl = typeof window !== 'undefined'
        ? `${window.location.origin}/api/tonconnect-manifest`
        : `${process.env.NEXT_PUBLIC_APP_URL || 'https://tokenkickstarter.com'}/tonconnect-manifest.json`

    return (
        <TonConnectUIProvider manifestUrl={manifestUrl}>
            {children}
        </TonConnectUIProvider>
    )
}
